import Vue from 'vue'
import ProductSelect from './ProductSelect.vue'
import AddPromotion from './AddPromotion.vue'
import DiscountedProduct from './DiscountedProduct.vue'
import SpecialPromotionItem from './SpecialPromotionItem.vue'
import EditableGrid from '../../components/EditableGrid.vue'
import uuid from 'uuid'
import EventProductRepository from '../../model/EventProductRepository'
import EventAndProductCombiningTransformer from '../../transformers/EventAndProductCombiningTransformer'

export default {
  name: 'EditEventItemsView',

  props: {
    eventStartDate: {
      type: String
    },
    eventEndDate: {
      type: String
    },
    customerGroups: {
      type: Array,
      required: true
    },
    regionId: {
      type: Number
    },
    eventId: {
      type: String,
      required: true
    },
    maxCustomerGroupId: {
      type: Number
    },
    isEventConfirmed: {
      type: Boolean
    },
    discountedProducts: {
      type: Array
    },
    specialPromotions: {
      type: Array
    },
    deletedDiscountsAndPromotions: {
      type: Array
    },
    $v: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      productBeingEdited: null,
      promotionBeingEdited: null,
      promotionBeingDeleted: null,

      productSelectShown: false,
      addPromotionShown: false,
      deletePromotionShow: false,

      gridFocused: true
    }
  },

  computed: {
    totalRows () {
      return this.discountedProducts.length + this.specialPromotions.length
    }
  },

  components: {
    'product-select': ProductSelect,
    'add-promotion': AddPromotion,
    'discounted-product': DiscountedProduct,
    'special-promotion': SpecialPromotionItem,
    'editable-grid': EditableGrid
  },

  methods: {
    addOrUpdateProduct (product) {
      let productToUpdate

      if (this.productBeingEdited) {
        productToUpdate = this.productBeingEdited
      } else {
        console.log("product--------------------------------------", this.customerGroups)
        let newProduct = {
          id: null,
          plu: null,
          name: null,
          customerGroupId: this.customerGroups[0].value,
          startDate: this.eventStartDate,
          endDate: this.eventEndDate,
          page: null,
          positionOnPage: null,
          regularPrice: null,
          regularCustomerGroupPrice: null,
          cost: null,
          salesPrice: null,
          targetMargin: null,
          rewardMoneyEarnedPerItem: null,
          hasBeenEdited: false,
          uuid: uuid.v4()
        }

        this.discountedProducts.push(newProduct)
        productToUpdate = this.discountedProducts[this.discountedProducts.length - 1]
      }

      let salesPrice
      if (productToUpdate.customerGroupId === this.customerGroups[0].value) {
        salesPrice = product.regionBasePrice
      } else {
        salesPrice = product.regionCustomerGroupBasePrice
      }

      productToUpdate.id = product.productID
      productToUpdate.plu = product.code
      productToUpdate.name = product.name
      productToUpdate.regularPrice = product.regionBasePrice
      productToUpdate.regularCustomerGroupPrice = product.regionCustomerGroupBasePrice
      productToUpdate.salesPrice = salesPrice
      productToUpdate.cost = product.regionCost
      productToUpdate.productId = product.id
      productToUpdate.hasBeenEdited = product.hasBeenEdited
    },
    // eslint-disable-next-line complexity
    addOrUpdatePromotion (promotion) {

      console.log('promotion: ', promotion);
      let combiningTransformer = new EventAndProductCombiningTransformer()

      let promotionToUpdate
      if (this.promotionBeingEdited) {
        promotionToUpdate = this.promotionBeingEdited
      } else {
        let newPromotion = {
          id: null,
          name: '',
          nameLat: '',
          type: null,
          startDate: this.eventStartDate,
          endDate: this.eventEndDate,
          customerGroupId: this.customerGroups[0].value,
          page: null,
          positionOnPage: null,
          targetMargin: null,
          oncePerDay: null,
          subsidyPercentageOfDiscount: null,
          rewardsSubsidy: 0,
          requirements: {
            purchaseTotalValue: null,
            purchasedAmount: null,
            purchasedProducts: []
          },
          rewards: {
            lowestPriceItemIsAwarded: null,
            redemptionLimit: null,
            salesRedemptionLimit: null,
            maxItemsWithSpecialUnitPrice: null,
            specialUnitPrice: null,
            rewardMoneyEarnedPerItem: null,
            rewardMoneyEarnedPerRedemption: null,
            awardedAmount: null,
            awardedProducts: [],
            sumOff: null,
            percentageOff: null
          },
          uuid: uuid.v4(),
          hasBeenEdited: false
        }
        this.specialPromotions.push(newPromotion)
        promotionToUpdate = this.specialPromotions[this.specialPromotions.length - 1]
      }
      let purchasedProducts = []
      if (promotion.requirements.purchasedProducts) {
        purchasedProducts = promotion.requirements.purchasedProducts.map(product => {

          console.log('pre mapProductChanges: ', product)
          const ret = Object.assign({}, combiningTransformer.mapProductChanges(product))

          console.log('!!!!!!!!!!!!!!!!!!!!!!!!!!!!!adding')
          console.log(ret)

          return ret
        })
        purchasedProducts.sort((product1, product2) => {
          if (product1.plu < product2.plu) {
            return -1
          } else if (product1.plu > product2.plu) {
            return 1
          } else {
            return 0
          }
        })
      }

      let awardedProducts = []
      if (promotion.rewards.awardedProducts) {
        awardedProducts = promotion.rewards.awardedProducts.map(product => Object.assign({}, product))
        awardedProducts.sort((product1, product2) => {
          if (product1.plu < product2.plu) {
            return -1
          } else if (product1.plu > product2.plu) {
            return 1
          } else {
            return 0
          }
        })
      }

      switch (promotion.type) {
        case 'SPEND_X_FOR_DISCOUNT':
        case 'SPEND_GET_SUM_OFF_ITEMS':
        case 'SPEND_GET_PERCENTAGE_OFF_ITEMS':
          promotionToUpdate.type = promotion.rewards.sumOff ? 'SPEND_GET_SUM_OFF_ITEMS' : 'SPEND_GET_PERCENTAGE_OFF_ITEMS'
          break
        case 'MULTI_BUY':
          promotionToUpdate.type = 'BUY_ITEMS_FOR_SPECIAL_UNIT_PRICE'
          break
        case 'BUY_X_FOR_DISCOUNT':
        case 'BUY_ITEMS_GET_SUM_OFF_ITEMS':
        case 'BUY_ITEMS_GET_PERCENTAGE_OFF_ITEMS':
          promotionToUpdate.type = promotion.rewards.sumOff ? 'BUY_ITEMS_GET_SUM_OFF_ITEMS' : 'BUY_ITEMS_GET_PERCENTAGE_OFF_ITEMS'
          break
        case 'MULTIBUY_X_FOR_DISCOUNT':
        case 'MULTIBUY_GET_SUM_OFF':
        case 'MULTIBUY_GET_PERCENTAGE_OFF':
          promotionToUpdate.type = promotion.rewards.sumOff ? 'MULTIBUY_GET_SUM_OFF' : 'MULTIBUY_GET_PERCENTAGE_OFF'
          break
        default:
          break
      }

      promotionToUpdate.name = promotion.name
      promotionToUpdate.nameLat = promotion.nameLat
      promotionToUpdate.rewardsSubsidy = promotion.rewardsSubsidy
      promotionToUpdate.oncePerDay = promotion.oncePerDay
      promotionToUpdate.targetMargin = promotion.targetMargin
      promotionToUpdate.subsidyPercentageOfDiscount = promotion.subsidyPercentageOfDiscount
      promotionToUpdate.hasBeenEdited = promotion.hasBeenEdited
      promotionToUpdate.requirements.purchasedAmount = promotion.requirements.purchasedAmount
      promotionToUpdate.requirements.purchasedProducts = purchasedProducts
      promotionToUpdate.requirements.purchaseTotalValue = promotion.requirements.purchaseTotalValue



      promotionToUpdate.rewards.sumOff = promotion.rewards.sumOff
      promotionToUpdate.rewards.percentageOff = promotion.rewards.percentageOff
      promotionToUpdate.rewards.awardedAmount = promotion.rewards.awardedAmount
      promotionToUpdate.rewards.awardedProducts = awardedProducts
      promotionToUpdate.rewards.maxItemsWithSpecialUnitPrice = promotion.rewards.maxItemsWithSpecialUnitPrice
      promotionToUpdate.rewards.specialUnitPrice = promotion.rewards.specialUnitPrice
      promotionToUpdate.rewards.redemptionLimit = promotion.rewards.redemptionLimit
      promotionToUpdate.rewards.salesRedemptionLimit = promotion.rewards.salesRedemptionLimit


      if (promotion.rewards.rewardMoneyEarnedPerItem) {
        promotionToUpdate.rewards.rewardMoneyEarnedPerItem = promotion.rewards.rewardMoneyEarnedPerItem
      } else {
        promotionToUpdate.rewards.rewardMoneyEarnedPerRedemption = promotion.rewards.rewardMoneyEarnedPerRedemption
      }

      console.log('promotionToUpdate modificator')
      console.log(promotionToUpdate)
      if (promotionToUpdate.type === 'MULTIBUY_X_FOR_DISCOUNT' || promotionToUpdate.type === 'MULTIBUY_GET_PERCENTAGE_OFF' || promotionToUpdate.type === 'MULTIBUY_GET_SUM_OFF') {
        console.log('promotionToUpdate modificator inside')
        promotionToUpdate.rewards.sumOffMatchingItems = promotionToUpdate.rewards.sumOff ? promotionToUpdate.rewards.sumOff.valueOf() : promotionToUpdate.rewards.sumOffMatchingItem

        promotionToUpdate.rewards.percentageOffMatchingItems = promotionToUpdate.rewards.percentageOff ? promotionToUpdate.rewards.percentageOff.valueOf() : promotionToUpdate.rewards.percentageOffMatchingItem
      }
      console.log('promotionToUpdate modificator after')
      console.log(promotionToUpdate)
    },

    deleteDiscount (item) {
      this.productBeingEdited = null
      Vue.nextTick(() => {
        this.deletedDiscountsAndPromotions.push(item)
        this.discountedProducts.splice(this.discountedProducts.indexOf(item), 1)
      })
    },

    deletePromotion () {
      this.promotionBeingEdited = null
      Vue.nextTick(() => {
        this.specialPromotions.splice(this.specialPromotions.indexOf(this.promotionBeingDeleted), 1)
        this.deletedDiscountsAndPromotions.push(this.promotionBeingDeleted)
        this.promotionBeingDeleted = null
      })
    },

    scrollItems (event) {
      let elem = this.$refs.itemsTableWrapper
      let scrollMultiplier = event.target.scrollLeft / (event.target.scrollWidth - event.target.offsetWidth)
      elem.scrollLeft = (elem.scrollWidth - elem.offsetWidth) * scrollMultiplier
    },

    showProductSelect (item) {
      if (item) {
        this.productBeingEdited = item
      } else {
        this.productBeingEdited = null
      }
      this.productSelectShown = true
    },

    showPromotion (item) {
      if (item) {
        this.promotionBeingEdited = item
      } else {
        this.promotionBeingEdited = null
      }
      this.addPromotionShown = true
    },

    showPromotionDelete (item) {
      this.promotionBeingDeleted = item
      this.deletePromotionShow = true
    }
  },
  created () {
    this.eventProductRepository = new EventProductRepository(this.$api)
  }
}



// WEBPACK FOOTER //
// ./src/views/EditEvent/EditEventItems.js